import { Fragment, type CSSProperties } from 'react'
import Link from 'src/components/Link'
import styles from './NewsletterLegalStrip.module.css'

const links = [
  { href: '/impressum', label: 'Impressum' },
  { href: '/datenschutzerklaerung', label: 'Datenschutz' },
  { href: '/agb', label: 'AGB' },
  { href: '/newsletter', label: 'Newsletter' },
  { href: '/kontakt', label: 'Kontakt' },
]

export default function NewsletterLegalStrip({ publisher, style }: { publisher: string; style?: CSSProperties }) {
  return <div className={styles.root} style={style} data-newsletter-legal-strip>
    <div className={styles.row}>
      <span className={styles.brand}>© {publisher}</span>
      <span className={styles.desktopSeparator} aria-hidden='true'>|</span>
      <nav className={styles.links} aria-label='Rechtliche Informationen und Newsletter'>
        {links.map((link, index) => <Fragment key={link.href}>
          {index > 0 && <span aria-hidden='true'>|</span>}
          <Link href={link.href}>{link.label}</Link>
        </Fragment>)}
      </nav>
    </div>
  </div>
}
